// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#tableauViz::-webkit-scrollbar {
    display: none !important;
  }
  .fullWidth #tabZoneId5 {
    width: 100% !important;
  }
  #tableauViz {
    width: 100% !important;
    margin:auto;
    -ms-overflow-style: none !important;  /* IE and Edge */
    scrollbar-width: none !important;  /* Firefox */
  }

  .fullWidth * {
    width: 100% !important;
}
  #centeringContainer {
    width: 100% !important;
    height: 100% !important;

  }
  #dashboard-spacer {
    width: 100% !important;
    height: 100% !important;
  }

  .fullWidth #centeringContainer {
    width: 100% !important;
    height: 100% !important;

  }

  .fullWidth #dashboard-spacer {
    width: 100% !important;
    height: 100% !important;
  }

  .fullWidth #tab-dashboard-region {
    width: 100% !important;
    height: 100% !important;
  }
   #tableauViz #main-content {
width:100% !important;
height: 100% !important;
  }

 .fullWidth .tab-zone .tab-widget .tabZoneSelected .tabZone-flipboard .fade-bg {
    width:100% !important; 
  } `, "",{"version":3,"sources":["webpack://./src/styles/tableau.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,WAAW;IACX,mCAAmC,GAAG,gBAAgB;IACtD,gCAAgC,GAAG,YAAY;EACjD;;EAEA;IACE,sBAAsB;AAC1B;EACE;IACE,sBAAsB;IACtB,uBAAuB;;EAEzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;;EAEzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;GACC;AACH,qBAAqB;AACrB,uBAAuB;EACrB;;CAED;IACG,qBAAqB;EACvB","sourcesContent":["#tableauViz::-webkit-scrollbar {\n    display: none !important;\n  }\n  .fullWidth #tabZoneId5 {\n    width: 100% !important;\n  }\n  #tableauViz {\n    width: 100% !important;\n    margin:auto;\n    -ms-overflow-style: none !important;  /* IE and Edge */\n    scrollbar-width: none !important;  /* Firefox */\n  }\n\n  .fullWidth * {\n    width: 100% !important;\n}\n  #centeringContainer {\n    width: 100% !important;\n    height: 100% !important;\n\n  }\n  #dashboard-spacer {\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .fullWidth #centeringContainer {\n    width: 100% !important;\n    height: 100% !important;\n\n  }\n\n  .fullWidth #dashboard-spacer {\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .fullWidth #tab-dashboard-region {\n    width: 100% !important;\n    height: 100% !important;\n  }\n   #tableauViz #main-content {\nwidth:100% !important;\nheight: 100% !important;\n  }\n\n .fullWidth .tab-zone .tab-widget .tabZoneSelected .tabZone-flipboard .fade-bg {\n    width:100% !important; \n  } "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
